// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum FHWAClasses {
	Unknown = 0,
	Class1 = 2,
	Class2 = 4,
	Class3 = 8,
	Class4 = 16,
	Class5 = 32,
	Class6 = 64,
	Class7 = 128,
	Class8 = 256,
	Class9 = 512,
	Class10 = 1024,
	Class11 = 2048,
	Class12 = 4096,
	Class13 = 8192,
}

export const FHWAClassesDisplayNames: { [key in keyof typeof FHWAClasses]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"Class1": "Class 1",
	2 : "Class 1",
	"Class2": "Class 2",
	4 : "Class 2",
	"Class3": "Class 3",
	8 : "Class 3",
	"Class4": "Class 4",
	16 : "Class 4",
	"Class5": "Class 5",
	32 : "Class 5",
	"Class6": "Class 6",
	64 : "Class 6",
	"Class7": "Class 7",
	128 : "Class 7",
	"Class8": "Class 8",
	256 : "Class 8",
	"Class9": "Class 9",
	512 : "Class 9",
	"Class10": "Class 10",
	1024 : "Class 10",
	"Class11": "Class 11",
	2048 : "Class 11",
	"Class12": "Class 12",
	4096 : "Class 12",
	"Class13": "Class 13",
	8192 : "Class 13",
}

export const getFHWAClassesDisplayName = (key: FHWAClasses | (keyof typeof FHWAClasses & string)) => {
	return FHWAClassesDisplayNames[key];
}

